import Moment from 'moment-timezone';
import store from '@/store';
import { i18n } from '@/plugins/i18n';
import { nestedFlatten } from '@/utils/main';
import { valueKeyFormat } from '@/utils/indicator-utils';

/** Utility class */
function IAHelp() {}
/** Creates indicators and values for the tutorial */
IAHelp.demoIndicators = function (app, nDays, first, indicatorsOnly) {
  const indics = [
    {
      id: 1, theme: 1020, name: app.$t('help.DEMO_INDIC1'), objective: 1200, objectives: {}, objectiveIsMax: 1, unit: 'd', type: 0, templateId: 0, inputPeriodUnit: 'd',
    },
    {
      id: 2, theme: 1020, name: app.$t('help.DEMO_INDIC2'), objective: 5000, objectives: {}, objectiveIsMax: 1, unit: '€', type: 0, templateId: 0, inputPeriodUnit: 'd',
    },
    {
      id: 3, theme: 1022, name: app.$t('help.DEMO_INDIC3'), objective: 60, objectives: {}, objectiveIsMax: 1, unit: 'min', type: 0, templateId: 0, inputPeriodUnit: 'd',
    },
    {
      id: 4, theme: 1023, name: app.$t('help.DEMO_INDIC4'), objective: 5, objectives: {}, objectiveIsMax: 1, unit: '€', type: 0, templateId: 0, inputPeriodUnit: 'd',
    },
    {
      id: 5, theme: 1023, name: app.$t('help.DEMO_INDIC5'), objective: 1, objectives: {}, objectiveIsMax: 1, unit: 'p', type: 0, templateId: 0, inputPeriodUnit: 'd',
    },
  ];
  const themes = [
    { id: 1, name: app.$t('help.DEMO_INDIC_QUALITY'), letter: app.$t('help.DEMO_INDIC_Q'), indicators: [indics[0], indics[1]] },
    { id: 2, name: app.$t('help.DEMO_INDIC_DELIVERY'), letter: app.$t('help.DEMO_INDIC_D'), indicators: [indics[2]] },
    { id: 3, name: app.$t('help.DEMO_INDIC_COSTS'), letter: app.$t('help.DEMO_INDIC_C'), indicators: [indics[3], indics[4]] },
  ];
  let i; const ilen = first ? 1 : themes.length; let j; let jlen; let theme; let
    indic;
  const endDate = Moment(); const
    startDate = endDate.clone().subtract(nDays || 30, 'd');
  do {
    for (i = 0; i < ilen; i++) {
      theme = themes[i];
      for (j = 0, jlen = first ? 1 : theme.indicators.length; j < jlen; j++) {
        indic = theme.indicators[j];
        if (first || indicatorsOnly) {
          indic.themeName = theme.name;
        }
        if (!indic.inputValues) {
          indic.inputValues = {};
        }
        const reported = startDate.format(valueKeyFormat);
        const valObj = {
          id: i * 30 + j,
          reported,
          value: (Number(indic.objective) + ((Math.random() * 0.1 - 0.05) * Number(indic.objective))).toFixed(0),
        };
        indic.inputValues[reported] = valObj;
      }
    }
  } while (startDate.add(1, 'days').diff(endDate) <= 0);
  return first
    ? themes[0].indicators[0]
    : indicatorsOnly ? indics : themes;
};
/** Creates tutorial probem types */
IAHelp.demoProblemTypes = function (app) {
  return [
    { id: 0, name: app.$t('message.UNSPECIFIED'), selected: true },
    { id: 1, name: app.$t('help.DEMO_TYPE1'), selected: false },
    { id: 2, name: app.$t('help.DEMO_TYPE2'), selected: false },
    { id: 3, name: app.$t('help.DEMO_TYPE3'), selected: false },
  ];
};
/** Creates tutorial probems */
IAHelp.demoProblems = function (app, full) {
  const mf = 'YYYY-MM-DD HH:mm:ss'; const yd = Moment().subtract(1, 'd').format(mf); const
    nd = Moment().format(mf);
  const problem = {
    id: 1,
    lWhat: app.$t('help.DEMO_PROBLEM1'),
    lWho: app.$t('help.DEMO_PROBLEM_WHO1'),
    lWhere: app.$t('help.DEMO_PROBLEM_WHERE1'),
    lWhen: app.$t('help.DEMO_PROBLEM_WHEN1'),
    lWhy: app.$t('help.DEMO_PROBLEM_WHY1'),
    lHow: app.$t('help.DEMO_PROBLEM_HOW1'),
    lHowMuch: '',
    created: nd,
    deadline: Moment().add(3, 'd').format(mf),
    impact: 2,
    type: 0,
    state: 3,
    affectTeam: app.currentTeam.id,
    indicators: [10019],
    ended: 0,
    ongoing: 1,
    pending: 1,
    keywords: [],
    pictures: [{ data: '/images/ia/demo/problem1.jpg' }],
    actions: [{
      id: 1,
      name: app.$t('help.DEMO_ACTION1'),
      cause: 1,
      leader: 0,
      impact: 0,
      state: 0,
      plan: 0,
      pdca: 1,
      gain: 0,
      deadline: Moment().add(5, 'H').format(mf),
      isSecuring: 0,
    }],
    wCauses: [{
      id: 1,
      text: app.$t('help.DEMO_CAUSE1'),
      pictures: [{ data: '/images/ia/demo/cause1.jpg' }],
      cause: 0,
      hideInSheet: 0,
      ishikawaBranch: 1,
      files: [],
      wCauses: [],
    }],
  };
  return full
    ? problem
    : [
      problem,
      {
        id: 2,
        lWhat: app.$t('help.DEMO_PROBLEM2'),
        created: nd,
        deadline: Moment().add(7, 'd').format(mf),
        impact: 2.4,
        type: 0,
        state: 1,
        affectTeam: app.currentTeam.id,
        ended: 0,
        ongoing: 1,
        pending: 1,
      },
    ];
};
IAHelp.demoCauses = app => [
  {
    id: 1,
    text: app.$t('help.DEMO_CAUSE1'),
    pictures: [{ data: '/images/ia/demo/cause1.jpg' }],
    cause: 0,
    hideInSheet: 0,
    ishikawaBranch: 2,
    files: [],
    wCauses: [
      {
        id: 2,
        text: app.$t('help.DEMO_CAUSE2'),
        pictures: [],
        cause: 1,
        hideInSheet: 0,
        ishikawaBranch: 2,
        files: [],
        wCauses: [],
      },
    ],
  },
  {
    id: 3,
    text: app.$t('help.DEMO_CAUSE3'),
    pictures: [],
    cause: 0,
    hideInSheet: 0,
    ishikawaBranch: 1,
    files: [],
    wCauses: [],
  },
];
/** Creates tutorial actions */
IAHelp.demoActionPlans = function (app, onlyActions) {
  const mf = 'YYYY-MM-DD HH:mm:ss';
  const sd = Moment().subtract(1, 'H').format(mf);
  const actions = [
    {
      id: 0,
      name: app.$t('help.DEMO_ACTION1'),
      plan: 1,
      leader: 0,
      pdca: 1,
      deadline: Moment().add(5, 'H').format(mf),
      reportTeam: 0,
      affectTeam: 0,
      added: sd,
      supportPlan: null,
    },
    {
      id: 1,
      name: app.$t('help.DEMO_ACTION2'),
      plan: 1,
      leader: 0,
      pdca: 2,
      deadline: Moment().add(3, 'H').format(mf),
      reportTeam: 0,
      affectTeam: 0,
      added: sd,
      supportPlan: null,
    },
  ];
  return onlyActions ? actions : [
    {
      id: 1, name: app.$t('help.SHORT_TERM'), actionDuration: 8, maxActions: 20, support: 0, nActions: 2, actions,
    },
    {
      id: 2,
      name: app.$t('help.LONG_TERM'),
      actionDuration: 72,
      maxActions: 20,
      support: 0,
      nActions: 2,
      actions: [
        {
          id: 2,
          name: app.$t('help.DEMO_ACTION3'),
          plan: 2,
          leader: 0,
          pdca: 3,
          deadline: Moment().subtract(2, 'H').format(mf),
          reportTeam: 0,
          affectTeam: 0,
          added: Moment().subtract(7, 'H').format(mf),
          supportPlan: null,
        },
        {
          id: 3,
          name: app.$t('help.DEMO_ACTION4'),
          plan: 2,
          leader: 0,
          pdca: 4,
          deadline: Moment().add(60, 'H').format(mf),
          reportTeam: 0,
          affectTeam: 0,
          added: sd,
          supportPlan: null,
        },
      ],
    },
    {
      id: 3,
      name: app.$t('help.SUPPORT'),
      actionDuration: 8,
      maxActions: 20,
      support: 1,
      nActions: 1,
      actions: [
        {
          id: 4,
          name: app.$t('help.DEMO_ACTION5'),
          plan: 3,
          leader: 0,
          pdca: 2,
          deadline: sd,
          reportTeam: 0,
          affectTeam: 0,
          added: sd,
          supportPlan: 2,
        },
      ],
    },
  ];
};

IAHelp.demoTeamsTree = [{
  id: 1,
  name: 'Shizen policy',
  hierarchyLevel: 3,
  accesses: [],
  users: [
    {
      id: 1001267,
      team: 100985,
      firstName: 'Brad',
      lastName: 'Pitt',
      accesses: [
        2,
        3,
      ],
      label: 'Brad Pitt',
    },
    {
      id: 1001268,
      team: 100985,
      firstName: 'Julia',
      lastName: 'Roberts',
      accesses: [
        0,
      ],
      label: 'Julia Roberts',
    },
  ],
  management: true,
  parentId: 0,
  parents: [],
  teams: [
    {
      id: 2,
      name: 'Shizen management, area I',
      hierarchyLevel: 2,
      accesses: [1001267],
      users: [
        {
          id: 1001502,
          team: 101029,
          firstName: 'Albert',
          lastName: 'Camus',
          accesses: [4, 5],
          label: 'Albert Camus',
        },
      ],
      management: true,
      parentId: 1,
      parents: [1],
      parentId0: 1,
      teams: [
        {
          id: 4,
          name: 'Shizen opérations I-A',
          hierarchyLevel: 1,
          accesses: [1001502],
          users: [],
          management: false,
          parentId: 2,
          parents: [2, 1],
          parentId0: 2,
          parentId1: 1,
          teams: [],
        },
        {
          id: 5,
          name: 'Shizen opérations I-B',
          hierarchyLevel: 1,
          accesses: [1001502],
          users: [],
          management: false,
          parentId: 2,
          parents: [2, 1],
          parentId0: 2,
          parentId1: 1,
          teams: [],
        },
      ],
    },
    {
      id: 3,
      name: 'Shizen management, area II',
      hierarchyLevel: 2,
      accesses: [1001267],
      users: [
        {
          id: 1001506,
          team: 101030,
          firstName: 'Fiodor',
          lastName: 'Dostoïevski',
          accesses: [6, 7],
          label: 'Fiodor Dostoïevski',
        },
      ],
      management: true,
      parentId: 1,
      parents: [1],
      parentId0: 1,
      teams: [
        {
          id: 6,
          name: 'Shizen opérations II-A',
          hierarchyLevel: 1,
          accesses: [1001506],
          users: [],
          management: false,
          parentId: 3,
          parents: [3, 1],
          parentId0: 3,
          parentId1: 1,
          teams: [],
        },
        {
          id: 7,
          name: 'Shizen opérations II-B',
          hierarchyLevel: 1,
          accesses: [1001506],
          users: [],
          management: false,
          parentId: 3,
          parents: [3, 1],
          parentId0: 3,
          parentId1: 1,
          teams: [],
        },
      ],
    },
  ],
}];
IAHelp.demoTeamsTreeFlattened = nestedFlatten(IAHelp.demoTeamsTree, 'teams', 'id');

IAHelp.demoOngoingGW = function () {
  return {
    id: 9,
    template: 1,
    name: i18n.t('help.DEMO_CV_GW'),
    objective: '',
    completed: 0,
    currentStep: 1,
    date: Moment().format('YYYY-MM-DD'),
    prevId: 8,
    canEdit: true,
    steps: [{
      id: 9,
      name: i18n.t('help.DEMO_CV_GW_STEP'),
      objective: '',
      duration: 1941,
      ok: 0,
      templateDuration: 0,
      zone: 0,
      auditedTeam: 101121,
      prevId: 8,
      teamName: i18n.t('help.DEMO_CV_TEAM_NAME'),
      comments: [],
      prevComments: [],
      problems: [],
      actions: [],
      checklists: [{
        id: 8,
        name: i18n.t('help.DEMO_CV_CL'),
        gwStep: 9,
        items: [{
          id: 71,
          checkList: 8,
          template: 1,
          text: i18n.t('help.DEMO_CV_CL_ITEM_1'),
          ok: 2,
          type: 0,
          indicator: null,
          gwIndicator: null,
          value: 0,
          orderKey: 0,
          dupId: 0,
          okValue: 2,
          objective: null,
          objectiveIsMax: null,
          problems: [],
          comments: [],
          files: [],
        }, {
          id: 72,
          checkList: 8,
          template: 2,
          text: i18n.t('help.DEMO_CV_CL_ITEM_2'),
          ok: 2,
          type: 0,
          indicator: null,
          gwIndicator: null,
          value: 0,
          orderKey: 1,
          dupId: 0,
          okValue: 2,
          objective: null,
          objectiveIsMax: null,
          problems: [],
          comments: [],
          files: [],
        }, {
          id: 73,
          checkList: 8,
          template: 3,
          text: i18n.t('help.DEMO_CV_CL_ITEM_3'),
          ok: 2,
          type: 0,
          indicator: null,
          gwIndicator: null,
          value: 0,
          orderKey: 2,
          dupId: 0,
          okValue: 2,
          objective: null,
          objectiveIsMax: null,
          problems: [],
          comments: [],
          files: [],
        }],
      }],
      prevCheckLists: [{
        id: 7,
        name: i18n.t('help.DEMO_CV_CL'),
        gwStep: 8,
        items: [{
          id: 61,
          checkList: 7,
          template: 1,
          text: i18n.t('help.DEMO_CV_CL_ITEM_1'),
          ok: 1,
          type: 0,
          indicator: null,
          gwIndicator: null,
          value: 0,
          orderKey: 0,
          dupId: 0,
          okValue: 1,
          objective: null,
          objectiveIsMax: null,
          problems: [],
          comments: [],
          files: [],
        }, {
          id: 62,
          checkList: 7,
          template: 2,
          text: i18n.t('help.DEMO_CV_CL_ITEM_2'),
          ok: 1,
          type: 0,
          indicator: null,
          gwIndicator: null,
          value: 0,
          orderKey: 1,
          dupId: 0,
          okValue: 1,
          objective: null,
          objectiveIsMax: null,
          problems: [],
          comments: [],
          files: [],
        }, {
          id: 63,
          checkList: 7,
          template: 3,
          text: i18n.t('help.DEMO_CV_CL_ITEM_3'),
          ok: 1,
          type: 0,
          indicator: null,
          gwIndicator: null,
          value: 0,
          orderKey: 2,
          dupId: 0,
          okValue: 1,
          objective: null,
          objectiveIsMax: null,
          problems: [],
          comments: [],
          files: [],
        }],
      }],
    }],
  };
};

IAHelp.demoGWChecklists = () => [
  {
    id: 0,
    name: i18n.t('help.DEMO_GW_CL1'),
    expanded: false,
    items: [
      { id: 0, text: i18n.t('help.DEMO_GW_CL_ITEM1'), type: 0 },
      { id: 1, text: i18n.t('help.DEMO_GW_CL_ITEM2'), type: 0 },
      { id: 2, text: i18n.t('help.DEMO_GW_CL_ITEM3'), type: 0 },
      { id: 3, text: i18n.t('help.DEMO_GW_CL_ITEM_DOTS'), type: 0 },
    ],
  },
  {
    id: 1,
    name: i18n.t('help.DEMO_GW_CL2'),
    expanded: false,
    items: [],
  },
];

IAHelp.demoGWTemplate = () => ({
  completed: '0',
  currentStep: '0',
  date: null,
  id: '1',
  name: i18n.t('help.DEMO_EVENT3'),
  objective: i18n.t('help.DEMO_GW_OBJECTIVE'),
  plannings: [{
    id: 1,
    participants: [],
    repeatType: 1,
    repeatData: { day: 1, time: '09:00' },
    teamName: store.state.currentTeam ? store.state.currentTeam.name : '',
  }],
  steps: [
    {
      id: 1,
      name: i18n.t('help.DEMO_GW_STEP1'),
      number: 1,
      objective: '',
      zone: 0,
      auditedTeam: 0,
      checklists: [0],
      duration: 90,
    },
    {
      id: 2,
      name: i18n.t('help.DEMO_GW_STEP2'),
      number: 2,
      objective: '',
      zone: 0,
      auditedTeam: 0,
      checklists: [],
      duration: 120,
    },
  ],
});

export default IAHelp;
